var render = function (_h,_vm) {var _c=_vm._c;return _c('li',{class:['checkout-summary-separator', _vm.data.class, _vm.data.staticClass]},[_c('hr')])}
var staticRenderFns = []

export { render, staticRenderFns }